import {css} from 'glamor';
import Immutable from 'immutable';

css.global(
  `
.DraftEditor-root,
.DraftEditor-editorContainer,
.public-DraftEditor-content`,
  {
    height: '100%',
  },
);

const blockStyleFnResult = css({
  margin: '0',
  verticalAlign: 'baseline',
  lineHeight: '1.6',
});

const blockStyleFn = () => blockStyleFnResult;

export const blockRenderMap = Immutable.Map({
  unstyled: {
    element: 'div',
  },
});

export default () => ({
  blockStyleFn,
});
